// Feature flags for gating unreleased functionality.
// Each flag maps to a Vite environment variable (set in .env or Netlify env vars).

export const ORG_BILLING_ENABLED =
  import.meta.env.VITE_ENABLE_ORG_BILLING === "true";
